<template>
    <div class="ma-5 pa-3">
        <v-tabs v-model="tab" background-color='transparent'>
            <v-tab v-for="tab in tabs" :key="tab" class="black--text">
            {{ tab }}
            </v-tab>    
            <v-tab-item>
                <v-card flat color="#f5f5f5">
                    <existingResearchers />
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat color="#f5f5f5">
                    <newResearchers />
                </v-card>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import existingResearchers from '@/components/researchers/existing_researchers'
import newResearchers from '@/components/researchers/new_researchers'
export default {
    name:'howToUse',
    components:{
        existingResearchers,
        newResearchers
    },
    data(){
        return {
            tab: null,
            tabs: [
                '既存リサーチャー', '新規リサーチャー',
            ], 
        }
    }
}
</script>